import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function IpWaitingList(){

  const [ipViewData, setIpViewData] = useState([]);

  useEffect(() => {
    fetchIpViewData();
  }, []);

  function fetchIpViewData() {
        const url = `${baseUrl}view-ip/?status=1`;
        axios.get(url)
          .then(response => {
            setIpViewData(response.data);
          })
          .catch(error => {
            console.log(error);
          });
  }

    const columns = [
        {field:'ip_id', headerName:'IP ID',
          renderCell: (params) => (
              <Link to={`/confirm-ip-admit/${params.row.id}/`}>
                {params.value}
              </Link>
          ),
          width: 100,
          },
        {field:'pat__pat_id', headerName:'Pat Id', width:40},
        {field:'pat__patient', headerName:'Patient', width:100},
        {field:'pat__age', headerName:'Age', width:10},
        {field:'pat__mobile', headerName:'Mobile', width:100},
        {field:'pat__address1', headerName:'Address', width:240},
        {field:'adhar', headerName:'Adhar', width:120},
        {field:'primary_consult__consultant', headerName:'Consultant', width:100},
        {field:'room_no__room_no', headerName:'Room No', width:75},
        {field:'payment', headerName:'Payment', width:100},
         { field: 'admit_date', headerName: 'Admitted On', width: 150,
    renderCell: (params) => (
      <span>{formatDateTime(params.value)}</span>
    ),
  },
        { field: 'action', headerName: 'Action',
          renderCell: (params) => (
              <Link to={`/confirm-ip-admit/${params.row.id}/`} className="btn btn-success">
                View
              </Link>
          ),
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
      ];
    return (
    <section className="container mt-4">
    <div className="row">
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
          <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
          Inpatient List
    </h3>
    {ipViewData.length > 0 ? (
        <div style={{ height: 300, width: '100%' }} className="mt-4">
            <DataGrid
            sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            }}
            rows= {ipViewData}
            columns= {columns}
            pageSize= {10}
            slots={{ toolbar: GridToolbar }}
            />
        </div>
    ) : (
      <></>
    )}
    </div>
    </section>
    )
}

export default IpWaitingList;
